import React, { useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Layout from './components/Layout';
import ClothesScreen from "./pages/ClothesScreen";
import AuthScreen from "./pages/AuthScreen";
import PrivateRoute from "./utils/PrivateRoute";
import CheckingPermissions from "./utils/CheckingPermissions";
import DetailsViewScreen from "./pages/DetailsViewScreen";
import LogsScreen from "./pages/LogsScreen";
import UsersScreen from "./pages/UsersScreen";
import ImageEvaluationScreen from "./pages/ImageEvaluationScreen/imageEvaluationScreen";
import NoAccessScreen from "./pages/NoAccessScreen/index";
import ColorClustersScreen from './pages/СolorСlustersScreen';
import FittingEvaluationScreen from './pages/FittingEvaluationScreen/fittingEvaluationScreen';
import TypesFigure from './modules/TypesFigure/TypesFigure';
import PersonalCapsuleList from './modules/PersonalCapsule/PersonalCapsuleList';
import ProfilePage from './modules/PersonalCapsule/PersonalCapsuleItem/ProfilePage';

import NotificationManager from './components/NotificationManager/NotificationManager';
import Redirection from "./utils/Redirection";
import PersonalCapsuleEvaluationScreen from "./pages/PersonalCapsuleEvaluation/PersonalCapsuleEvaluationScreen";

function NavigationHandler() {
    const navigate = useNavigate();

    useEffect(() => {
        const handleServiceWorkerMessage = (event: MessageEvent) => {
            if (event.data?.type === 'NAVIGATE') {
                const path = event.data.path;
                navigate(path);
            }
        };

        navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);

        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({
                type: 'PING'
            });
        }

        return () => {
            navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
        };
    }, [navigate]);

    return null;
}

function AppRoutes() {
    return (
        <>
            <Routes>
                <Route path="/" element={<PrivateRoute> <Layout /> </PrivateRoute>}>
                    <Route index element={<CheckingPermissions requiredPermission="clothes"><ClothesScreen/> </CheckingPermissions>} />
                    <Route path="/details/:clothId" element={<CheckingPermissions requiredPermission="clothes"><DetailsViewScreen/></CheckingPermissions>} />
                    <Route path="/create/" element={<CheckingPermissions requiredPermission="clothes"><DetailsViewScreen/></CheckingPermissions>} />
                    <Route path="/logs" element={<CheckingPermissions requiredPermission="logs"><LogsScreen/></CheckingPermissions>} />
                    <Route path="/users" element={<CheckingPermissions requiredPermission="users"><UsersScreen/></CheckingPermissions>} />
                    <Route path="/feedback" element={<CheckingPermissions requiredPermission="feedback"><ImageEvaluationScreen/></CheckingPermissions>} />
                    <Route path="/feedbackfitting" element={<CheckingPermissions requiredPermission="feedbackfitting"><FittingEvaluationScreen/></CheckingPermissions>} />
                    <Route path="/feedbackPersonalCapsule" element={<CheckingPermissions requiredPermission="feedbackfitting"><PersonalCapsuleEvaluationScreen/></CheckingPermissions>} />
                    <Route path="/personalCapsuleList" element={<CheckingPermissions requiredPermission="сolorСlusters"><PersonalCapsuleList/></CheckingPermissions>} />
                    <Route path="/user/:userId" element={<CheckingPermissions requiredPermission="сolorСlusters"><ProfilePage/></CheckingPermissions>} />
                </Route>
                <Route path="/login" element={<AuthScreen />} />
                <Route path="*" element={<div>404: Page not found</div>} />
                <Route path="/no_access" element={<NoAccessScreen/>} />
                <Route path="/app/download" element={<Redirection/>} />
            </Routes>
        </>
    );
}

function App() {
    return (
        <div>
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>

            <ToastContainer
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                limit={5}
            />
        </div>
    );
}

export default App;